import { NodeType } from '@amplify/amp-module';
import { objectToSortedArray } from './amp-utils';

export const buildStack = (node, conversationNodes, stack = [], additionalStackData = {}) => {
  if (node) {
    const conversationList = objectToSortedArray(conversationNodes);

    if (node.parentId) {
      const parentNode = conversationList.find((n) => node.parentId.startsWith(n.id));

      if (parentNode?.type === NodeType.buttonGroup || parentNode?.type === NodeType.question) {
        const subNode = Object.values(parentNode.subNodes).find((n) => node.parentId.endsWith(n.id));
        buildStack(parentNode, conversationNodes, stack, { selectedButtonId: `${subNode.id}-0` });
      } else if (parentNode) {
        buildStack(parentNode, conversationNodes, stack);
      }
    }

    stack.push({
      node,
      storage: {},
      ...additionalStackData,
    });
  }

  return stack;
};
